import React, { useState, useEffect } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { connect } from 'react-redux';
import { Form, Input, Button, message, Select, TreeSelect, Checkbox } from 'antd';
import * as Constants from '../../../constants';
import { cloudFunctions, db } from '../../../config/Fire';
import { getCompanies } from '../../../reducers';

const { Option } = Select
const { TreeNode } = TreeSelect

const FormNewUser = (props) => {
	const [isSaving, setIsSaving] = useState(false)
	const [isEmployee, setIsEmployee] = useState(false)
	const [isConstruction, setIsConstruction] = useState(false)
	const [isSadeEmployee, setIsSadeEmployee] = useState(false)
	const [contractors, setContractors] = useState([])

    const [form] = Form.useForm();

    // Props para controlar tipos de usuario permitidos y valor por defecto
    const allowedUserTypes = props.allowedUserTypes || Object.keys(Constants.userTypesMap)
    const defaultUserType = props.defaultUserType || null
    const showDniField = props.showDniField || false
    // Asegurarse de que constructionUsers sea siempre un array
    const constructionUsers = Array.isArray(props.constructionUsers) ? props.constructionUsers : []
    // Establecer el valor por defecto del tipo de usuario si se especifica
    useEffect(() => {
        if (defaultUserType) {
            form.setFieldsValue({ user_type: defaultUserType })
            // Si el tipo por defecto es EMPLOYEE, activar el estado isEmployee
            if (defaultUserType === 'EMPLOYEE') {
                setIsEmployee(true)
            }
            if (defaultUserType === 'CONSTRUCTION') {
                setIsConstruction(true)
            }
        }
    }, [defaultUserType, form])

	useEffect(() => {
		db.ref('contractors').once('value').then(snapshot => {
			if (snapshot.exists()) {
				setContractors(snapshot.val() || [])
			}
		}).catch(console.error)
	}, [])

	const handleReset = () => {
		setIsSaving(false)
		setIsEmployee(false)
		setIsConstruction(false)
		setIsSadeEmployee(false)
		form.resetFields();
		// Restaurar el valor por defecto del tipo de usuario si existe
		if (defaultUserType) {
			form.setFieldsValue({ user_type: defaultUserType })
			if (defaultUserType === 'EMPLOYEE') {
				setIsEmployee(true)
			}
			if (defaultUserType === 'CONSTRUCTION') {
				setIsConstruction(true)
			}
		}
	};

    const handleSubmit = values => {
        var employeeCategories = {}
        var companiesIds = {}
        if (values.categories_assigned) {
            values.categories_assigned.forEach(categoryAssigned => {
                var pathSplit = categoryAssigned.split('/');
                companiesIds[pathSplit[0]] = true
                var res = categoryAssigned.replace(/\//g, "_");
                employeeCategories[res] = true
            });
        }
        const data = {
            name: values.name,
            email: values.email,
            password: values.password,
            userType: values.user_type,
            employeeCategories,
            companiesIds
        }
		if (values.user_type === 'CONSTRUCTION') {
			data.category = values.category || null
			data.enableMultipleRecords = values.enableMultipleRecords || false
			data.emergencyPhone = values.emergencyPhone || null
			data.emergencyContactReference = values.emergencyContactReference || null
			data.realAddress = values.realAddress || null
			data.isSadeEmployee = values.isSadeEmployee || false
			data.contractor = values.isSadeEmployee ? null : (values.contractor || null)
		}
        if (values.dni) {
            const numericDni = parseInt(values.dni)
            // Solo validar duplicados si showDniField es true y constructionUsers está disponible
            if (showDniField && constructionUsers.length > 0) {
                const dniExists = constructionUsers.some(user => {
                    const userDni = user.dni ? parseInt(user.dni) : null
                    return userDni === numericDni
                })
                if (dniExists) {
                    message.error("El DNI ya está en uso.")
                    return
                }
            }
            data.dni = numericDni
        }
        submit(data);
    };

    const submit = data => {
        setIsSaving(true)
        cloudFunctions.createUser(data)
            .then(response => {
                setIsSaving(false)
                if (response && response.data && response.data.code !== undefined) {
                    if (response.data.code === 1 && response.data.error) {
                        var error = response.data.error.errorInfo;
                        if (error && error.code && (error.code === "auth/invalid-password" || error.code === "auth/user-not-found")) {
                            message.error("La contraseña debe tener al menos 6 caracteres.");
                        } else {
                            if (error && error.code && error.code === "auth/invalid-email") {
                                message.error("Email incorrecto.");
                            } else {
                                if (error && error.code && error.code === "auth/email-already-exists") {
                                    message.error("El email ya está en uso.");
                                } else {
                                    if (error && error.code && error.code === "auth/too-many-requests") {
                                        message.error("Se realizaron demasiados intentos. Por favor, intente mas tarde o contactese con soporte.");
                                    } else {
                                        console.log(JSON.stringify(error))
                                        message.error("Se produjo un error. Vuelva a intentarlo más tarde.");
                                    }
                                }
                            }
                        }
                    } else {
                        if (response.data.code === 0) {
                            message.success('¡El usuario se guardó exitósamente!');
                            setIsEmployee(false)
                            setIsConstruction(false)
                            form.resetFields();
                            // Restaurar el valor por defecto del tipo de usuario si existe
                            if (defaultUserType) {
                                form.setFieldsValue({ user_type: defaultUserType })
                                if (defaultUserType === 'EMPLOYEE') {
                                    setIsEmployee(true)
                                }
                                if (defaultUserType === 'CONSTRUCTION') {
                                    setIsConstruction(true)
                                }
                            }
                        } else {
                            message.error("Se produjo un error. Vuelva a intentarlo más tarde.");
                            console.log("ERROR: " + JSON.stringify(response))
                        }
                    }
                } else {
                    message.error("Se produjo un error. Vuelva a intentarlo más tarde.");
                    console.log("ERROR: " + JSON.stringify(response))
                }
            }).catch(error => {
                console.log("ERROR: " + JSON.stringify(error))
                setIsSaving(false)
                message.error("Se produjo un error. Vuelva a intentarlo más tarde.");
            })
    };

    const onSelectUserType = value => {
        if (Constants.userTypesMap.EMPLOYEE === Constants.userTypesMap[value]) {
            setIsEmployee(true)
            setIsConstruction(false)
        } else if (value === 'CONSTRUCTION') {
            setIsEmployee(false)
            setIsConstruction(true)
        } else {
            setIsEmployee(false)
            setIsConstruction(false)
        }
    }

    const { companies } = props;

    // Preparar initialValues con el tipo de usuario por defecto si se especifica
    const initialValues = { password: 'gruposade' }
    if (defaultUserType) {
        initialValues.user_type = defaultUserType
    }

    return (
        <Grid className="gridCont">
            <Form onFinish={handleSubmit} form={form} initialValues={initialValues}>
                <Row>
                    <Col xs={12} sm={6} md={6}>
                        <Form.Item name="name" rules={[{ required: true, message: 'Por favor, ingresa el nombre completo del usuario' }]}>
                            <Input placeholder="Nombre completo" />
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={6} md={6}>
                        <Form.Item name="email" rules={[{ required: true, message: 'Por favor, ingresa el correo electrónico del usuario' }]}>
                            <Input placeholder="Correo electrónico" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={6} md={6}>
                        <Form.Item name="password" rules={[{ required: true, message: 'Por favor, ingresa la contraseña del usuario' }]}>
                            <Input disabled minLength="6" placeholder="Contraseña" />
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={6} md={6}>
                        <Form.Item name="user_type" rules={[{ required: true, message: 'Por favor, seleccione un tipo de usuario' }]}>
                            <Select
                                defaultActiveFirstOption={true}
                                placeholder="Tipo de usuario"
                                onSelect={onSelectUserType}
                                disabled={allowedUserTypes.length === 1}>
                                {
                                    Constants.userTypesMap && Object.keys(Constants.userTypesMap)
                                        .filter(key => allowedUserTypes.includes(key))
                                        .map(key => <Option key={key} value={key}>{Constants.userTypesMap[key]}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                {(showDniField || isConstruction) && (
                    <>
                        <Row>
                            <Col xs={12} sm={4} md={4}>
                                <Form.Item name="dni" rules={[{ required: true, message: 'Por favor, ingresa el DNI del usuario' }]}>
                                    <Input
                                        placeholder="DNI"
                                        maxLength={10}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, '')
                                            form.setFieldsValue({ dni: value })
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={12} sm={4} md={4}>
                                <Form.Item name="category" rules={[{ required: true, message: 'Por favor, seleccione una categoría' }]}>
                                    <Select placeholder="Categoría">
                                        {
                                            Constants.OPERATOR_CATEGORIES && Object.keys(Constants.OPERATOR_CATEGORIES).map(key =>
                                                <Option key={key} value={key}>{Constants.OPERATOR_CATEGORIES[key]}</Option>
                                            )
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xs={12} sm={4} md={4}>
                                <Form.Item name="enableMultipleRecords" valuePropName="checked">
                                    <Checkbox>Multiples registros</Checkbox>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={4} md={4}>
                                <Form.Item name="emergencyPhone">
                                    <Input placeholder="Número de emergencia" />
                                </Form.Item>
                            </Col>
                            <Col xs={12} sm={4} md={4}>
                                <Form.Item name="emergencyContactReference">
                                    <Input placeholder="Referencia de emergencia" />
                                </Form.Item>
                            </Col>
                            <Col xs={12} sm={4} md={4}>
                                <Form.Item name="realAddress">
                                    <Input placeholder="Domicilio real" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row style={{ display: 'flex', alignItems: 'center' }}>
                            <Col xs={12} sm={4} md={4} style={{ marginBottom: 24 }}>
                                <Form.Item name="isSadeEmployee" valuePropName="checked" style={{ margin: 0 }}>
                                    <Checkbox onChange={e => setIsSadeEmployee(e.target.checked)}>Empleado de Grupo SADE</Checkbox>
                                </Form.Item>
                            </Col>
                            <Col xs={12} sm={8} md={8}>
                                <Form.Item
                                    name="contractor"
                                    label="Contratista responsable"
                                    rules={[{ required: !isSadeEmployee, message: 'Por favor, seleccione un contratista' }]}
                                >
                                    <Select
                                        placeholder="Seleccione un contratista"
                                        disabled={isSadeEmployee}
                                        allowClear
                                    >
                                        {
                                            contractors.map(name =>
                                                <Option key={name} value={name}>{name}</Option>
                                            )
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
			</>
		)}

                {isEmployee &&
                    <Row center="xs">
                        <Col xs={12} sm={6} md={6}>
                            <Form.Item name="categories_assigned" rules={[{ required: true, message: 'Por favor, seleccione al menos una categoría' }]}>
                                <TreeSelect
                                    showSearch
                                    style={{ width: '100%' }}
                                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                    placeholder="Categorías a las que pertenece"
                                    allowClear
                                    multiple
                                    treeCheckable>
                                    {
                                        companies && Object.keys(companies).map(key => {
                                            return (
                                                <TreeNode value={key} title={companies[key].name} key={key}>
                                                    {
                                                        companies[key].clientProceduresCategories &&
                                                        <TreeNode value={`${key}/clientProceduresCategories`} title="Categorias para clientes" key={`${key}/clientProceduresCategories`}>
                                                            {
                                                                Object.keys(companies[key].clientProceduresCategories).map(keyClientProceduresCategories => {
                                                                    return (
                                                                        <TreeNode value={`${key}/clientProceduresCategories/${keyClientProceduresCategories}`} title={keyClientProceduresCategories} key={`${key}/clientProceduresCategories/${keyClientProceduresCategories}`}>
                                                                            {
                                                                                Object.keys(companies[key].clientProceduresCategories[keyClientProceduresCategories]).map(subKeyClientProceduresCategories => {
                                                                                    if (companies[key].clientProceduresCategories[keyClientProceduresCategories][subKeyClientProceduresCategories] !== true) {
                                                                                        return (
                                                                                            <TreeNode value={`${key}/clientProceduresCategories/${keyClientProceduresCategories}/${subKeyClientProceduresCategories}`} title={subKeyClientProceduresCategories} key={`${key}/clientProceduresCategories/${keyClientProceduresCategories}/${subKeyClientProceduresCategories}`}>
                                                                                            </TreeNode>
                                                                                        )
                                                                                    }
                                                                                })
                                                                            }
                                                                        </TreeNode>
                                                                    )
                                                                })
                                                            }
                                                        </TreeNode>
                                                    }
                                                    {
                                                        companies[key].publicProceduresCategories &&
                                                        <TreeNode value={`${key}/publicProceduresCategories`} title="Categorias para publico general" key={`${key}/publicProceduresCategories`}>
                                                            {
                                                                Object.keys(companies[key].publicProceduresCategories).map(keyPublicProceduresCategories => {
                                                                    return (
                                                                        <TreeNode value={`${key}/publicProceduresCategories/${keyPublicProceduresCategories}`} title={keyPublicProceduresCategories} key={`${key}/publicProceduresCategories/${keyPublicProceduresCategories}`}>
                                                                        </TreeNode>
                                                                    )
                                                                })
                                                            }
                                                        </TreeNode>
                                                    }
                                                </TreeNode>
                                            )
                                        })
                                    }
                                </TreeSelect>
                            </Form.Item>
                        </Col>
                    </Row>
                }
                <Form.Item>
                    <Row center="xs">
                        <Col xs={3} sm={3} md={3}></Col>
                        <Col xs={3} sm={3} md={3}>
                            {
                                isSaving ?
                                    <Button type="primary" htmlType="submit" disabled={true} loading>
                                        Enviar
                                    </Button>
                                    :
                                    <Button type="primary" htmlType="submit" disabled={false}>
                                        Enviar
                                    </Button>
                            }
                        </Col>
                        <Col xs={3} sm={3} md={3}>
                            <Button onClick={handleReset}>
                                Limpiar
                            </Button>
                        </Col>
                        <Col xs={3} sm={3} md={3}></Col>
                    </Row>
                </Form.Item>
            </Form>
        </Grid>
    );
}

FormNewUser.propTypes = {

};

const mapDispatchToPropsActions = dispatch => ({
});

const mapStateToProps = state => ({
    companies: getCompanies(state),
});

export default connect(mapStateToProps, mapDispatchToPropsActions)(FormNewUser);
